import { Typography } from "@mui/material";
import { ActionField } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { getActionFieldUnit, isFieldStartingDataInsufficient } from "../../../ImpactSection/utils";
import { ActionFieldInputComponent } from "../Inputs/ActionFieldInputComponent";
import { useMyActionPlanContext } from "../../../../context/useMyActionPlan";
import { StartingValues } from "./StartingValues";
import { getFieldStartingValues } from "./fieldStartingValues";

type ActionFieldSimpleProps = {
    field: ActionField;
};

export const ActionFieldSimple = (props: ActionFieldSimpleProps) => {
    const { isFieldValueUpdating, selectedActionPlan } = useActionsContext();
    const { isEditMode, actionPlanAction, fieldValues, startingPost } = useMyActionPlanContext();
    const { field } = props;

    const isInsufficient = isFieldStartingDataInsufficient(field, actionPlanAction) || isFieldValueUpdating;
    const isNotEditable = isEditMode === true;

    const disabled = isInsufficient || isFieldValueUpdating || isNotEditable;

    const unit = getActionFieldUnit(field);
    const fieldType = field.field?.type ?? "text";
    const fieldValue = fieldValues?.find((v) => {
        return v.actionFieldId === field.id;
    });

    // When we talk about Simple and Group, position is 0;
    const position = 0;

    const actionFieldId = field.id;

    const startingValues = getFieldStartingValues(field, startingPost?.elements ?? [], position);

    const startingYear = selectedActionPlan?.metadata.startingPost.campaign?.label;

    return (
        <>
            <Typography variant="h4">{field.question}</Typography>
            <ActionFieldInputComponent
                fieldValue={fieldValue}
                dataListOptions={field.dataList?.options}
                unit={unit}
                fieldType={fieldType}
                disabled={disabled}
                position={position}
                actionFieldId={actionFieldId}
            />
            <StartingValues year={startingYear} values={startingValues} />
        </>
    );
};
